import axios from 'axios'
import store from "./stop_aja";

axios.defaults.withCredentials=false;
const CancelToken = axios.CancelToken;
axios.interceptors.request.use(function (response) {
    // response.headers.Authorization = sessionStorage.getItem("ACCESS_TOKRN");
    // response.cancelToken = new CancelToken((cancel) => {
    //    store._axiosPromiseCancel.push(cancel);
    // });
   return response;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(res=>{
        return res;
    },error=>{
        if (axios.isCancel(error)) {
            // 为了终结promise链 就是实际请求 不会走到.catch(rej=>{});这样就不会触发错误提示之类了。
            return new Promise(() => {});
        }else{
            return Promise.reject(error)
        }
	}
);

export default function axio(url, params, gets) {
    let formData = null;
    if(params){
        formData = new FormData();
        Object.keys(params).forEach((key) => {
            formData.append(key, params[key]);
        });
    }else{
        formData = params
    }
    return new Promise((resolve, reject) => {
        if (gets) {
            axios.get(url, {params:formData})
                .then(response => {
                    if (response.data.code == 200) {
                        resolve(response.data);
                    }else{
                        alert(response.data.msg);
                        // router.push('/');
                    }
                })
                .catch(function (err) {
                    // loadingInstance.close();
                    if (err && err.response) {
                        switch (err.response.status) {
                            case 400:
                                alert("请求错误，请重试！！！");
                                break;
                            case 403:
                                alert("拒绝访问，请重试！！！");
                                break;
                            case 404 || 405:
                                alert("请求地址出错，请重试！！！");
                                break;
                            case 408:
                                alert('请求超时，请重试！！！');
                                break;
                            case 500 || 501 || 502 || 503 || 504:
                                alert('网络错误，请稍后再试');
                            default:
                        }
                    }
                })
        } else {
            axios.post(url, formData)
                .then(response => {
                    if (response.data.code == 200) {
                        resolve(response.data)
                    }else{
                        alert(response.data.msg)
                    }
                })
                .catch(function (err) {
                    // loadingInstance.close();
                    if (err && err.response) {
                        switch (err.response.status) {
                            case 400:
                                alert("请求错误，请重试！！！");
                                break;
                            case 403:
                                alert("拒绝访问，请重试！！！");
                                break;
                            case 404 || 405:
                                alert("请求地址出错，请重试！！！");
                                break;
                            case 408:
                                alert('请求超时，请重试！！！');
                                break;
                            case 500 || 501 || 502 || 503 || 504:
                                alert('网络错误，请稍后再试');
                            default:
                        }
                    }
                })
        }

    })
}
